var AkrolabCart = {
    init:function(){
            
        if(document.querySelectorAll("cart-drawer .swiper-container").length > 0){
            var _swiper_container = document.querySelector("cart-drawer .swiper-container");

            var swiper = new Swiper(_swiper_container, {
                slidesPerView: "auto",
                spaceBetween: 30,
                navigation: {
                    nextEl: _swiper_container.querySelector(".swiper-button-next"),
                    prevEl: _swiper_container.querySelector(".swiper-button-prev"),
                    },
                pagination: {
                    el: _swiper_container.querySelector(".swiper-pagination"),
                    clickable:true
                },                
            });
        }
        document.querySelector(".cart-drawer__overlay").addEventListener("click", function(e){
            e.preventDefault();
            e.stopPropagation();

            document.querySelector("cart-drawer").classList.remove('active');
            document.querySelector("body").classList.remove('overflow-hidden');
        } );

        document.querySelector(".cart-drawer__overlay").addEventListener("mousemove", function(e){
            AkrolabCart.move_btn_close(e);
        });        
        document.querySelector("#cart-gift").addEventListener("change", function(){
            if(document.querySelector("#cart-gift").checked){
                document.querySelector(".gift-message__container").classList.add("selected");
            }else{
                document.querySelector(".gift-message__container").classList.remove("selected");
            }
        });

        document.querySelectorAll(".product-card-wrapper__mini-cart .btn__add-to-cart").forEach(function(btn){
            btn.addEventListener("click", function(){
               AkrolabCart.add_product_to_cart(btn.getAttribute("data-id"));
            })
        })


        window.addEventListener("resize", function(){
            AkrolabCart.resize();
        });
        AkrolabCart.resize();
    },
    
    move_btn_close:function(e){
        document.querySelector(".cart-drawer__overlay .cart-overlay_btn-close").style.left = e.clientX + "px";
        document.querySelector(".cart-drawer__overlay .cart-overlay_btn-close").style.top = e.clientY + "px";
    },

    add_product_to_cart:function(id){
        var xhr = new XMLHttpRequest();
        xhr.open("POST", window.Shopify.routes.root + 'cart/add.js', true);
        xhr.setRequestHeader('Content-Type', 'application/json');

        xhr.onreadystatechange = function() {
            if (xhr.readyState == XMLHttpRequest.DONE) {
                response = JSON.parse(xhr.responseText);
                if (typeof response.items !== 'undefined')  {
                    //REMOVE IS EMPTY
                    document.querySelector("cart-drawer").classList.remove("is-empty");

                    document.querySelector('cart-drawer').innerHTML = AkrolabCart.getSectionInnerHTML(response.sections['cart-drawer'], 'cart-drawer');
                    document.querySelector('#cart-icon-bubble').innerHTML = AkrolabCart.getSectionInnerHTML(response.sections['cart-icon-bubble']);
                    setTimeout((() => {
                        document.querySelector('cart-drawer').classList.add("animate","active");
                    }))
                }else{
                    // ADD IS EMPTY
                    console.log("RESPONSE ITEMS IS EMPTY");
                    console.log(response.message);
                }
                setTimeout(function(){
                    AkrolabCart.init();
                }, 10);
            }
        }

        xhr.send(JSON.stringify({
            items: [{
                id: id,
                quantity: 1
            }],
            sections: "cart-drawer,cart-icon-bubble"
        }));
    },
    getSectionInnerHTML: function(html, selector = ".shopify-section") {
        return (new DOMParser).parseFromString(html, "text/html").querySelector(selector).innerHTML
    },
    resize:function(){

        var _container = document.querySelector(".cart__arguments__content");
        var _content = document.querySelector(".cart__argument__repeater");
        
        if(_container.offsetWidth < _content.offsetWidth){
            document.querySelector(".cart__arguments").classList.add("animated");
        }else{
            document.querySelector(".cart__arguments").classList.remove("animated");
        }
    },

}


window.addEventListener("load", function(){
    if(document.querySelectorAll("cart-drawer").length > 0){
        AkrolabCart.init();
    }
})